var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container my-5"},[_c('div',{staticClass:"AccordionsBlock"},_vm._l((_vm.accordions),function(accordion){return _c('Accordion',{key:accordion._id,staticClass:"accordion-item",attrs:{"accordion":accordion,"variant":"faq"}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }